import React, { useState, createContext, useEffect, useContext } from 'react';

const UserContext = createContext(null);

export const useUser = () => useContext(UserContext);

interface UserProviderProps {
  children: React.ReactNode;
}
export default function UserProvider({ children }: UserProviderProps) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const getUser = async (): Promise<void> => {
      const loginButton = document.getElementById('loginButton') as IdKamigameLoginButton;
      const loginUser = await loginButton.getUser();
      if (!loginUser) {
        loginButton.click();
      }

      setUser(loginUser);
    };

    getUser();
  }, []);

  const defaultContext = {
    user,
  };

  return <UserContext.Provider value={defaultContext}>{user ? children : <h1>Loading...</h1>}</UserContext.Provider>;
}
